import { render, staticRenderFns } from "./card_orders.vue?vue&type=template&id=198043b4&scoped=true"
import script from "./card_orders.vue?vue&type=script&lang=js"
export * from "./card_orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198043b4",
  null
  
)

export default component.exports